'use client';

import * as React from 'react';
import { CreateStaffModalContent } from '@/app/dashboard/staff-settings/all-staff/components/create-staff-modal-content';
import { useAppSelector } from '@/store/hooks';
import { getUi } from '@/store/reducers/ui-slice';

import { ModalDrawer } from '@/types/general';

import { ModalLayout } from '../core/modal-layout';

export function CreateStaffModal(): React.JSX.Element | null {
  const { modal } = useAppSelector(getUi);

  return (
    <ModalLayout title="Create Staff" isOpen={modal?.open === ModalDrawer.CREATE_STAFF}>
      <CreateStaffModalContent />
    </ModalLayout>
  );
}
